<template>
  <a
    v-bind:href="url"
    >
    <slot></slot>
  </a>
</template>